/**
 * @component SectionHeading
 * @description 페이지별 반복되는 섹션 제목/아이브로우/설명 블록을 일관된 스타일로 제공하는 공통 컴포넌트입니다.
 * @usage Home, Company, Solution, Contact 등 주요 섹션의 헤더 블록에서 재사용됩니다.
 */

export default function SectionHeading({ eyebrow, title, description, compact = false, className = '' }) {
  const headingClassName = ['section-heading', compact ? 'compact' : '', className].filter(Boolean).join(' ');

  return (
    <div className={headingClassName}>
      {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
      {title ? <h2>{title}</h2> : null}
      {description ? <p>{description}</p> : null}
    </div>
  );
}
